/* tslint:disable */
/* eslint-disable */
/**
 * driverPortal fleet-registration api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { DriverRegistrationLogStatus } from './DriverRegistrationLogStatus';
import type { DriverRegistrationLogSource } from './DriverRegistrationLogSource';

export interface SubmittedDriverRegistrationLogResponse {
    id: number;
    /** min length: 40, max length: 40 */
    hash: string;
    country: string | null;
    city_id: number | null;
    language: string | null;
    status: DriverRegistrationLogStatus;
    source: DriverRegistrationLogSource;
    data: string | null;
    remote_training_url: string | null;
    flow_id: number | null;
}
